var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBin6Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "44897948-F5FE-468E-9BB3-2500006BA927") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Saved-Itineraries-1-Copy-4",
    transform: "translate(-840.000000, -611.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(117.000000, 529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(690.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete-bin-6-line",
    transform: "translate(33.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75,3.5 L8.75,0 L26.25,0 L26.25,3.5 L35,3.5 L35,7 L31.5,7 L31.5,33.25 C31.5,34.216525 30.716525,35 29.75,35 L5.25,35 C4.28351,35 3.5,34.216525 3.5,33.25 L3.5,7 L0,7 L0,3.5 L8.75,3.5 Z M7,7 L7,31.5 L28,31.5 L28,7 L7,7 Z M12.25,12.25 L15.75,12.25 L15.75,26.25 L12.25,26.25 L12.25,12.25 Z M19.25,12.25 L22.75,12.25 L22.75,26.25 L19.25,26.25 L19.25,12.25 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin6Line);
export default __webpack_public_path__ + "static/media/delete-bin-6-line.6f018979c94f8470430de8e598aff728.svg";
export { ForwardRef as ReactComponent };